export const PRIMARY_COLOR = '#1A2A63'
export const PRIMARY_TEXT_COLOR = '#ffffff'

export const PRIMARY_GRAY = '#4e4e4e'
export const SECONDARY_GRAY = '#ababab'